module.exports = __webpack_public_path__ + "img/67_M9_follow_footprints.1e640a0d.jpg";